export default "__VITE_ASSET__cc9feb24__"